import React, { useState } from "react";
import FailureModal from "../components/modal/FailureModal";
import LoadingModal from "../components/modal/LoadingModal";
import ProcessingModal from "../components/modal/ProcessingModal";
import SuccessModal from "../components/modal/SuccessModal";
import BookingFailedModal from "../components/modal/BookingFailedModal";

const TestComponents = () => {
  const [activeModal, setActiveModal] = useState(null);

  const closeModal = () => setActiveModal(null);

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8 border-b pb-4">
          Component Gallery
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Failure Modal */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
            <h2 className="text-xl font-semibold mb-4 text-gray-800">Failure Modal</h2>
            <p className="text-gray-600 mb-6 text-sm">
              Displayed when a payment or booking attempt fails.
            </p>
            <button
              onClick={() => setActiveModal("failure")}
              className="w-full bg-orange-500 text-white py-2 rounded-lg font-medium hover:bg-orange-600 transition-colors"
            >
              Preview Failure Modal
            </button>
          </div>

          {/* Success Modal */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
            <h2 className="text-xl font-semibold mb-4 text-gray-800">Success Modal</h2>
            <p className="text-gray-600 mb-6 text-sm">
              Displayed upon successful payment/validation.
            </p>
            <button
              onClick={() => setActiveModal("success")}
              className="w-full bg-green-600 text-white py-2 rounded-lg font-medium hover:bg-green-700 transition-colors"
            >
              Preview Success Modal
            </button>
          </div>

          {/* Processing Modal */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
            <h2 className="text-xl font-semibold mb-4 text-gray-800">Processing Modal</h2>
            <p className="text-gray-600 mb-6 text-sm">
              Full-screen overlay shown during active transactions.
            </p>
            <button
              onClick={() => setActiveModal("processing")}
              className="w-full bg-blue-600 text-white py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors"
            >
              Preview Processing Modal
            </button>
          </div>

          {/* Loading Modal */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
            <h2 className="text-xl font-semibold mb-4 text-gray-800">Loading Modal</h2>
            <p className="text-gray-600 mb-6 text-sm">
              A configurable loading modal with warnings.
            </p>
            <button
              onClick={() => setActiveModal("loading")}
              className="w-full bg-gray-800 text-white py-2 rounded-lg font-medium hover:bg-gray-900 transition-colors"
            >
              Preview Loading Modal
            </button>
          </div>

          {/* Booking Failed Modal */}
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
            <h2 className="text-xl font-semibold mb-4 text-gray-800">Booking Failed Modal</h2>
            <p className="text-gray-600 mb-6 text-sm">
              Payment success, but ticket issuing failed (timeline style).
            </p>
            <button
              onClick={() => setActiveModal("booking_failed")}
              className="w-full bg-red-600 text-white py-2 rounded-lg font-medium hover:bg-red-700 transition-colors"
            >
              Preview Booking Failed
            </button>
          </div>
        </div>

        {/* Modal Rendering */}
        {activeModal === "failure" && (
          <FailureModal
            onRetry={closeModal}
            onContactSupport={() => alert("Contacting support...")}
            errorMessage="The transaction was declined by your bank. Please try another card."
          />
        )}

        {activeModal === "success" && (
          <SuccessModal
            onClose={closeModal}
            ticketDetails={{ pnr: "ABC123" }}
          />
        )}

        {activeModal === "booking_failed" && (
          <BookingFailedModal 
            bookingId="RCFB-2025-X99"
            onClose={closeModal}
            onContactSupport={() => alert("Contacting support...")}
          />
        )}

        {activeModal === "processing" && (
          <ProcessingModal
            title="Validating Payment"
            message="We are currently confirming your transaction with the bank."
          />
        )}

        {/* Processing/Loading Modals often block the screen, so add a clear close mechanism for testing if they don't have one */}
        {(activeModal === "processing" || activeModal === "loading") && (
          <button 
            onClick={closeModal}
            className="fixed top-4 right-4 z-[60] bg-white rounded-full p-2 shadow-lg border border-gray-200 text-gray-500 hover:text-gray-800"
            title="Close Preview (Test Tool Only)"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}

        <LoadingModal 
          isOpen={activeModal === "loading"}
          title="Searching for Flights"
          message="Fetching the latest prices for your selected route..."
        />
      </div>
    </div>
  );
};

export default TestComponents;
